import React from "react";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";

let AdminDashboard = () => {
  return (
    <div>
      <div className="wrapper">
        <div>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 col-sm-6 col-md-3">
                    <div className="info-box">
                      <span className="info-box-icon bg-danger elevation-1">
                        <i className="fa fa-list" />
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Total Surveys</span>
                        <span className="info-box-number">100</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-md-3">
                    <div className="info-box mb-3">
                      <span className="info-box-icon bg-primary elevation-1">
                        <i className="fas fa-thumbs-up" />
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Launched</span>
                        <span className="info-box-number">70</span>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-md-3">
                    <div className="info-box mb-3">
                      <span className="info-box-icon bg-success elevation-1">
                        <i className="fas fa-shopping-cart" />
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Released</span>
                        <span className="info-box-number">20</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-md-3">
                    <div className="info-box mb-3">
                      <span className="info-box-icon bg-warning elevation-1">
                        <i className="fas fa-users" />
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Completed</span>
                        <span className="info-box-number">10</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
